import { Api } from '../api';
import { auth } from '../endpoints';
import type { ApiResponse } from '../../models';
import type {
  AuthenticateRequest,
  AuthTokenResponse,
  ForgotRequest,
  ForgotResponse,
  RefreshTokenRequest,
  SigninRequest,
  SigninResponse,
  SignupRequest,
  SignupResponse,
} from './models';

export class AuthApi extends Api {
  static signin = (request: SigninRequest) => this.post<SigninRequest, SigninResponse>({ url: auth.signin(), data: request });

  static async signup(request: SignupRequest) {
    const result = await this.post<SignupRequest, ApiResponse<SignupResponse>>({ url: auth.signup(), data: request });
    // This function is incomplete
    return result.data;
  }

  static forgot = (request: ForgotRequest) => this.post<ForgotRequest, ForgotResponse>({ url: auth.forgot(), data: request });

  static refreshToken = async (token: string) => {
    const result = await this.post<RefreshTokenRequest, ApiResponse<AuthTokenResponse>>({ url: auth.refreshToken(), data: { refreshToken: token } });
    if (!result.data?.refreshToken) result.data!.refreshToken = token;
    return result.data!;
  };

  static authenticate = async (request: AuthenticateRequest) => {
    const result = await this.post<AuthenticateRequest, ApiResponse<AuthTokenResponse>>({ url: auth.authenticate(), data: request });
    return result.data;
  };
}
